// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"475":"1fe2faa3","621":"531d3154","743":"5412fc7e"}[chunkId] + ".chunk.js";
};